import React, { createContext, useContext, useEffect, useState } from "react";
import { locales } from "./locales";

const I18nContext = createContext(null);

function getPath(obj, path) {
  return path.split(".").reduce((o, k) => (o ? o[k] : undefined), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mediflow_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("mediflow_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key, fallback) => {
    const v = getPath(locales[lang], key);
    if (typeof v === "string") return v;
    const en = getPath(locales.en, key);
    return typeof en === "string" ? en : fallback || key;
  };

  const value = { lang, setLang, t };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}

export function formatMoney(amount, currency = "XOF") {
  try {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(amount || 0);
  } catch {
    return `${amount} ${currency}`;
  }
}

export function formatDate(d, lang = "fr") {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleDateString(lang === "fr" ? "fr-FR" : "en-GB", {
      year: "numeric", month: "short", day: "2-digit",
    });
  } catch {
    return String(d);
  }
}

export function formatDateTime(d, lang = "fr") {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleString(lang === "fr" ? "fr-FR" : "en-GB", {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return String(d);
  }
}
